import React from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterBar = ({ 
  searchQuery, 
  onSearchChange, 
  dateRange, 
  onDateRangeChange,
  statusFilter,
  onStatusFilterChange,
  onExport,
  onRefresh
}) => {
  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' },
    { value: 'quarter', label: 'Last 90 Days' },
    { value: 'year', label: 'Last Year' },
    { value: 'all', label: 'All Time' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'pending', label: 'Pending' },
    { value: 'complete', label: 'Complete' },
    { value: 'error', label: 'Error' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-sm mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1 min-w-0">
          <Input
            type="search"
            placeholder="Search by name, email, address..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-3 lg:gap-4">
          <Select
            options={dateRangeOptions}
            value={dateRange}
            onChange={onDateRangeChange}
            placeholder="Date Range"
            className="w-full sm:w-48"
          />

          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusFilterChange}
            placeholder="Status"
            className="w-full sm:w-40"
          />

          <div className="flex gap-2">
            <Button
              variant="outline"
              iconName="RefreshCw"
              onClick={onRefresh}
              className="flex-1 sm:flex-none"
            >
              Refresh
            </Button>

            <Button
              variant="outline"
              iconName="Download"
              onClick={onExport}
              className="flex-1 sm:flex-none"
            >
              Export
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;